import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from '@/store/store';
import App from '@/App';
import '@/index.css';
import { setRemountCallback } from '@/utils/remountApp';

const root = ReactDOM.createRoot(document.getElementById('root'));

function Root() {
    const [key, setKey] = useState(0);

    useEffect(() => {
        setRemountCallback(() => setKey((prev) => prev + 1));
    }, []);

    return (
        <React.StrictMode key={key}>
            <Provider store={store}>
                <PersistGate persistor={persistor}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        </React.StrictMode>
    );
}
root.render(<Root />);
